export enum ResponsiveBehavior {
  STACKED = 'STACKED',
  SCROLL = 'SCROLL',
}
